import styled, { css } from 'styled-components'

import ActionButton from '../ActionButton'
import breakpoints from '../../theme/breakpoints'

const LinkStyles = css`
  color: ${({ theme }) => theme.colors.grey};
  font-weight: bold;
`

export const GpdrOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  z-index: 10;
`

export const Container = styled.div`
  width: calc(100% - 4rem);
  max-width: 74rem;
  margin: 0 auto;
  position: fixed;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background-color: white;
  padding: 3rem 2rem;
  z-index: 12;
  border-radius: 2rem;

  ${breakpoints.up('tablet')} {
    width: 100%;
    padding: 3rem 5rem;
  }
`

export const Logo = styled.img`
  width: 8.5rem;
  height: 6.2rem;
`

export const Title = styled.h2`
  ${({ theme }) => theme.textStyles.H3};
  color: ${({ theme }) => theme.colors.pureBlack};
`

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  gap: 2rem;
  padding: 0;
`

export const DescriptionWrapper = styled.div`
  color: ${({ theme }) => theme.colors.nightRider};
  ${({ theme }) => theme.textStyles.textLarge};
  line-height: 2.2rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  margin-bottom: 2rem;

  ${breakpoints.up('tablet')} {
    margin-bottom: 0;
    padding-left: 0;
    padding-right: 0;
  }
`

export const Description = styled.div`
  a {
    ${LinkStyles};
  }
`

export const GdprSettings = styled.p`
  ${LinkStyles};
  text-decoration: underline;
  cursor: pointer;
`

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 1rem;
`

export const ButtonAccept = styled(ActionButton)`
  flex: 1;
`

export const ButtonRefuse = styled(ActionButton)`
  flex: 1;
`
